<template>
  <div style="margin-top:10px;">
    <el-row align="bottom">
      <el-col :span="16">
        <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize" layout="prev,pager,next" :total="pageTotal" ></el-pagination>
      </el-col>
    </el-row>
    <!-- <el-divider></el-divider> -->
    <el-table :data="tableData" @expand-change="tableChange" :expand-row-keys="expands" row-key="id" stripe border ref="table2" @selection-change="selectionChange">
      <el-table-column type="expand" prop="childdata" size="small">
        <span slot-scope="scopes">
          <el-table :data="orderProductArr" border align="center" stripe>
            <el-table-column prop="warehouseName" label="供应商" width="200">
              <span slot-scope="scope">{{ scope.row.warehouseUserName?scope.row.warehouseUserName:scope.row.supWarehouseCode }}</span>
            </el-table-column>
            <el-table-column prop="productName" label="图书名称" />
            <el-table-column prop="productSn" label="ISBN" width="200" />
            <el-table-column prop="marketPrice" label="定价" width="90" />
            <el-table-column prop="discount" label="折扣" width="90" />
            <el-table-column prop="shopPrice" label="折扣价" width="90" />
            <el-table-column prop="productNumber" label="数量" width="90" />
            <!-- <el-table-column prop="productAssigned" label="已配送" width="90"/> -->
          </el-table>
          <div>
            <el-tag type="info" effect="plain">
              <b>收货人</b>：{{ scopes.row.consignee }}&#8195; <b>收货地址</b>：
              {{ scopes.row.provinceText }}
              {{ scopes.row.cityText }}
              {{ scopes.row.districtText }}&#8195;
              {{ scopes.row.address }}&#8195; <b>联系电话</b>：{{scopes.row.mobile}}&#8195;
            </el-tag>
          </div>
          <div>
            <el-tag type="info" effect="plain">
              <b>客户下单备注</b>：{{ scopes.row.payNote }}
            </el-tag>
          </div>
        </span>
      </el-table-column>
      <el-table-column align="center" width="45" label="全选" type="selection"></el-table-column>
      <el-table-column align="center" prop="orderSn" label="订单编号" ></el-table-column>
      <!-- <el-table-column align="center" label="订单编号" >
        <template slot-scope="scope">
          <el-link :underline="false" @click="mergePayOrder(scope.row)">{{scope.row.orderSn}}</el-link>
        </template>
      </el-table-column> -->
      <el-table-column align="center" prop="goodsAmount" label="数量" width="75"></el-table-column>
      <el-table-column align="center" prop="orderMoneyOriginal" width="75" label="定价"></el-table-column>
      <!-- <el-table-column
        align="center"
        prop="discount"
        label="折扣"
        width="75"
      ></el-table-column> -->
      <el-table-column align="center" prop="orderMoney" label="折扣价" width="75"></el-table-column>
      <!-- <el-table-column align="center" prop="expenses" label="运费" width="75"></el-table-column> -->
      <el-table-column align="center" prop="addTime" label="订单时间"></el-table-column>
      <el-table-column align="center" prop="orderStatus_dictText" label="订单状态" width="80"></el-table-column>
      <el-table-column align="center" prop="payStatus_dictText" label="付款状态" width="80"></el-table-column>
      <!-- <el-table-column align="center" prop="shippingStatus_dictText" label="发货状态" width="80"></el-table-column> -->
    </el-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getAction, deleteAction } from "../../../api/index";
export default {
  name: "orderCancel",
  inject: ['parentQueryParam'],
  data() {
    return {
      tableData: [],
      expands: [],
      multipleSelection: [],
      orderProductArr: [],
      queryParam: {
        isbn: "",
        orderSn: "",
        beginTime: "",
        endTime: "",
      },
      backForm: {
        id: "",
        backNumber: "",
        backType: "",
        backDesc: "",
        backMoney: 0.0,
      },
      url: {
        getorderLit: "/whOrder/queryList",
        selectOrderProductByOrderId: "/whOrder/selectOrderProductByOrderId",
        delOrder: "/whOrder/delete",
        exportExcel: "/whOrder/exportExcel",
        mergePayOrder: "/whOrder/mergePayOrder",
      },
      currentPage: 1, // 当前页码
      pagesize: 10, // 每页显示的行数
      pageTotal: 0,
      dialogVisible: false,
      backNumberMax: 0,
      orderList: {},
      resultOtherData:{},
    };
  },
  components: {},
  computed: {
    ...mapGetters(["isNaName"]),
  },
  mounted() {},
  created() {
    this.getOrderList(1);
  },
  methods: {
    getOrderList(page, isbn, orderSn, beginTime, endTime, consignee, tel, haveRemarkFlag) {
      const that = this
      getAction(that.url.getorderLit, {
        pageNo: page,
        orderStatus: -1,
        whUId: that.$store.state.userInfo.id,
        isbn: isbn,
        orderSn: orderSn,
        createTime_begin: beginTime,
        createTime_end: endTime,
        consignee: consignee,
        tel: tel,
        haveRemarkFlag: haveRemarkFlag,
      }).then((res) => {
        if (res.data.success) {
          console.log("res.data :>> ", res.data);
          // this.orderProductListMap = res.data.result.orderProductListMap;
          // this.tableData = res.data.result.orderListPage.records;
          // this.pageTotal = res.data.result.orderListPage.total;
          // this.expands = res.data.result.expands;
          that.tableData = res.data.result.records;
          that.pageTotal = res.data.result.total;
          that.resultOtherData = res.data.resultOther
        }
      });
    },
    selectionChange(row) {
      //  console.log("selectionChange========",row);
      this.multipleSelection = row;
      this.$emit('selectionChange',this.multipleSelection)
    },
    tableChange(row, expandedRows) {
      //订单展开，查询订单里的产品信息
      var that = this;
      if (expandedRows.length) {
        that.expands = [];
        if (row) {
          that.expands.push(row.id); // 每次push进去的是每行的ID
        }
      } else {
        that.expands = []; // 默认不展开
      }
      let id = row.id;
      getAction(this.url.selectOrderProductByOrderId, { 
        id: id , 
        'productSn': this.parentQueryParam.isbn, 
        orderSource: '1',
        userId: this.$store.state.userInfo.id
      }).then(
        (res) => {
          if (res.data.success) {
            this.orderProductArr = res.data.result;
            this.$forceUpdate();
          }
        }
      );
    },
    //嵌套表的复选框事件
    // subtableSelectionChange(row) {
    //   this.multipleSelection.push(row.id);
    //   console.log('this.multipleSelection :>> ', this.multipleSelection);
    //   // row.rows.forEach((d) => {
    //   //   d.selected = row.selectAll;
    //   // });
    // },
    delOrder(row) {
      this.$confirm("取消此订单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteAction(this.url.delOrder, { id: row.id }).then((res) => {
            if (res.data.success) {
              this.$message({
                type: "success",
                message: "订单已取消！",
              });
              this.loadList(1)
            }
          });
        })
        .catch(() => {});
    },
    loadList(pageNo){
      let isbn = this.parentQueryParam.isbn;
      let orderSn = this.parentQueryParam.orderSn;
      let createTime_begin = this.parentQueryParam.beginTime;
      let createTime_end = this.parentQueryParam.endTime;
      let consignee = this.parentQueryParam.consignee;
      let tel = this.parentQueryParam.tel;
      let haveRemarkFlag = this.parentQueryParam.haveRemarkFlag;
      this.getOrderList(pageNo, isbn, orderSn, createTime_begin, createTime_end, consignee, tel, haveRemarkFlag);
    },
    // 页面切换方法
    handleCurrentChange(val) {
      // this.getOrderList(val);
      this.loadList(val);
      this.currentPage = val;
    },
    mergePayOrder(obj) {
      this.orderList = {};
      this.orderList = obj;

      this.$router.push({
        path: "/orderDetial",
        params: {
          orderList: this.orderList,
          orderStatus: 4,
        },
        name: "订单明细",
      });
    },
    toogleExpand(row) {
      let $table = this.$refs.table2;
      $table.toggleRowExpansion(row);
      console.log(this.$route.params.taskId);
    },
  },
};
</script>

<style lang="scss" scoped>

/*2.展开按钮未点击的样式是加号带边框*/
::v-deep .el-table__expand-icon .el-icon-arrow-right:before {
  color: #000;
  font-size: 18px;
}


$mainColor: #5cadff;
.contentTitle {
  h1 {
    font-weight: normal;
    font-size: 30px;
    color: #757575;
  }
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
  line-height: 36px;
  background: #e5e9f2;
}
.demo-form-inline {
  margin-top: 1%;
}
// .el-col-2{
//     text-align: right !important;
// }
.el-divider {
  margin: 7px 0 !important;
}
.option {
  ul.category {
    float: left;
    height: 22px;
    padding: 10px 0;
    li {
      float: left;
      a {
        font-size: 16px;
        color: #757575;
        &:hover {
          color: $mainColor;
        }
      }
      span {
        margin: 0 20px;
      }
      &:last-child {
        span {
          display: none;
        }
      }
      &.active {
        a {
          color: $mainColor;
        }
      }
    }
  }
}
.header-search {
  float: right;
  form {
    position: relative;
    .searchPart {
      float: left;
      width: 245px;
      height: 50px;
      transition: all linear 0.2s 0s;
      border: 1px solid #e0e0e0;
      border-right: 0;
      box-sizing: border-box;
      input {
        width: calc(100% - 10px);
        height: 100%;
        outline: none;
        padding: 0 0 0 10px;
        &::-webkit-input-placeholder {
          color: #757575;
        }
      }
    }
    &:hover {
      .searchPart {
        border-color: #b0b0b0;
      }
      .sumbitPart {
        button {
          border-color: #b0b0b0;
        }
      }
    }
    .sumbitPart {
      float: left;
      button {
        cursor: pointer;
        width: 50px;
        height: 50px;
        border: 1px solid #e0e0e0;
        box-sizing: border-box;
        background-color: #fff;
        transition: all linear 0.2s 0s;
        span {
          color: #616161;
          font-size: 20px;
        }
      }
      &:hover {
        button {
          background-color: $mainColor;
          border: 1px solid $mainColor;
          span {
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
